import { TransporterEnum } from '../../../models/enums/transporter-enum.enum';

export class FeatureUtil {
  static BETA_ANALYTICS_TRANSPORTER_ALLOWED = [
    TransporterEnum.GOEVIA.technicalName,
    TransporterEnum.CLOT.technicalName,
    TransporterEnum.MORIN.technicalName,
    TransporterEnum.TPC.technicalName,
    TransporterEnum.TDF.technicalName,
    TransporterEnum.DGS_ONECLICK.technicalName,
    TransporterEnum.AGENEAU.technicalName,
  ];

  public static isAnalyticsTransporter(technicalName: string): boolean {
    return FeatureUtil.BETA_ANALYTICS_TRANSPORTER_ALLOWED.includes(technicalName);
  }
}
